import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_EP_RICHIESTA_PERMESSO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDEpRichiestaState extends EntityState<IID_EP_RICHIESTA_PERMESSO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_EP_RICHIESTA_PERMESSO , realtimeEntity: 'IID_EP_RichiestaPermesso'})
@InterfaceDataStore(InterfaceName.RICHIESTA_PERMESSO)
export class IIDEpRichiestaStore extends EntityStore<IIDEpRichiestaState> {
  constructor() {
    super([]);
  }
}